
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import moment from 'moment';

@Component({
	components: {
		AmountDisplayerFilterable,
	},
})
export default class BpTotalAssetsNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public amount: number = 0;

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		const table = getTableName('transactions');
		const systemTable = getTableName('system');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions', 'system', 'stockBalances']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.3);

		const [assetsResult, systemResult] = await Promise.all([
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
				FROM ${table}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
					AND "ACCTYPE" IN ('CA', 'FA', 'OA', 'IV')
			`),
			queryHead.rawQuery(`
				SELECT "VAL" FROM ${systemTable} LIMIT 1
			`),
		]);
		this.checkInterrupted(jobId);

		const assetsTotal = Number(assetsResult[0] && assetsResult[0].total) || 0;
		const startFinancialYear = systemResult[0] && systemResult[0].VAL;

		const stockBalance = await this._getStockMovement(queryHead, [
			moment(startFinancialYear, 'DD/MM/YYYY').valueOf(),
			this.selectedAsOfDate,
		]);

		this.amount = assetsTotal + (stockBalance * -1);

		this.saveHistory('amount');
	}
}
